export default {
  child: {
    not: {
      first: {
        margin: {
          top: '1.25rem',
        },
      },
    },
  },
  content_display: 'flow-root',
  item_display: 'list-item',
  list_style: 'none',
  open_symbol: '"+"',
  closed_symbol: '"-"',
  padding: 0,
  text_align: '-webkit-match-parent',
  toggle_display: 'flex',
  toggle_justification: 'space-between',
  toggle_font_size: '1.25rem',
  toggle_line_height: 1.4,
  closed_overflow: 'hidden',
  open_overflow: 'visible',
};
